export const LIST_SPECIAL_DEAL_USER = 'LIST_SPECIAL_DEAL_USER'
export const REMOVE_SPECIAL_DEAL_USER = 'REMOVE_SPECIAL_DEAL_USER'
export const DETAIL_SPECIAL_DEAL_USER = 'DETAIL_SPECIAL_DEAL_USER'
